import React from 'react';
import { faHandBackPointRight } from '@fortawesome/pro-regular-svg-icons/faHandBackPointRight';
import { faHyphen } from '@fortawesome/pro-regular-svg-icons/faHyphen';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { playbackSpeeds } from '../../context/VideoPlayerProvider';

const reversedSpeeds = playbackSpeeds.reverse();
export type PlaybackSpeedSelectorProps = {
  playbackRate: number;
  setPlaybackRate: (value: number) => void;
};

/**
 * Playback speed selector for video controls.
 */
export default function PlaybackSpeedSelector({
  playbackRate,
  setPlaybackRate,
}: PlaybackSpeedSelectorProps): JSX.Element {
  return (
    <Flex cn="flex-col w-[90  px] py-2">
      {reversedSpeeds.map((value) => {
        const isCurrent = playbackRate === value;
        return (
          <Button
            cn={`items-center justify-between gap-1 ${
              isCurrent ? 'opacity-100' : 'opacity-50'
            }`}
            key={value}
            data-testid={`playback-speed-button-${value}x`}
            onClick={(): void => setPlaybackRate(value)}
            variant="transparent"
          >
            <Icon icon={isCurrent ? faHandBackPointRight : faHyphen} />
            <P>
              {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
              {value.toFixed(1)}x
            </P>
          </Button>
        );
      })}
    </Flex>
  );
}
